import { Action, createReducer, on } from '@ngrx/store';

import { Error } from './global-error.models';
import { GlobalErrorActions } from './global-error.actions';

export interface GlobalErrorState {
  entity: Error | null;
}

const initialState: GlobalErrorState = {
  entity: null,
};

const globalErrorReducer = createReducer(
  initialState,
  on(
    GlobalErrorActions.handleError,
    (state, { error }): GlobalErrorState => ({
      ...state,
      entity: error,
    })
  ),
  on(
    GlobalErrorActions.clearError,
    (state): GlobalErrorState => ({
      ...state,
      entity: null,
    })
  )
);

export function reducer(state: GlobalErrorState | undefined, action: Action) {
  return globalErrorReducer(state, action);
}
